import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterHealthStatus } from './z-printer-health-status';

@MappedClass()
export class ZPrinterPrinterHealthEntry {
  @MappedProperty()
  id?: string;

  @MappedProperty()
  ip?: string;

  @MappedProperty()
  name?: string;

  @MappedProperty()
  network_reachable?: boolean;

  @MappedProperty()
  printer_status?: string;

  @MappedProperty()
  status?: ZPrinterHealthStatus;
}
